<template>
    <div>
        <b-alert
                variant="danger"
                :show="error"
        >
            {{'revisions.error_ocurred_try_again_later' | trans}}
            <div v-if="errorMessage">
                <br/>
                {{ errorMessage }}
            </div>
        </b-alert>
        <b-alert
                variant="success"
                :show="message != null && message.length > 0"
                dismissible>
            {{message}}
        </b-alert>
        <b-alert
                variant="warning"
                :show="isWithinEditWindow"
                dismissible>
            {{'revisions.edit_window_countdown' | trans}}: {{ formatTime(remainingEditTime) }}
        </b-alert>
        <form v-show="showForm" @submit.prevent="onSubmit" @keydown="onKeyUp($event)" @change="onKeyUp($event)">
            <div>
                <inner-form
                        :categories="categories"
                        :months="months"
                        :quarters="quarters"
                        :years="years"
                        :halfYears="halfYears"
                        :form="form"
                        :previousRevision="previousRevision"
                        :error="error"
                        :errorGeoCode="errorGeoCode"
                ></inner-form>

                <div class="mb-4">
                    <b-card :title="'revisions.comments' | trans">
                        <p class="card-text">
                        <ul class="pl-0">
                            <li style="list-style: none;" class="mb-1" v-for="comment in form.comments"
                                v-bind:key="comment.id">
                                {{comment.user.name}} {{comment.as_moderator ? '(Moderator)' : ''}}: {{comment.comment}}
                                <div style="font-size: 10px; color: lightgray;">{{formatDate(comment.created_at)}}</div>
                            </li>
                        </ul>
                        <hr>
                        <b-form-group
                                :label="'revisions.comment' | trans"
                                label-for="comment"
                                :invalid-feedback="form.errors.gets('comment')"
                                :state="form.errors.getState('comment')">
                            <b-textarea
                                    id="comment"
                                    v-model="form.comment"
                                    :state="form.errors.getState('comment')"
                                    :rows="3"
                            ></b-textarea>
                        </b-form-group>
                        </p>
                    </b-card>
                </div>
                <div class="mb-4">
                    <duplicates :duplicates="duplicates" :is-loading="isLoadingDuplicates"></duplicates>
                </div>
                <div class="mb-4">
                    <b-button variant="success" @click.prevent.stop="onSubmit" :disabled="this.isSending">{{'revisions.submit' | trans}}</b-button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    import Form from "../helper/form";
    import Errors from "../helper/errors";

    let moment = require("moment");

    export default {
        props: {
            categories: {
                type: Array,
                default: function () {
                    return [];
                }
            },
            months: {
                type: Array,
                default: function () {
                    return [];
                }
            },
            quarters: {
                type: Object,
                default: function () {
                    return {};
                }
            },
            halfYears: {
                type: Object,
                default: function () {
                    return {};
                }
            },
            years: {
                type: Array,
                default: function () {
                    return [];
                }
            },
            revision: {
                type: Object,
                default: function () {
                    return undefined;
                }
            },
            redirectBackAfterSuccess: {
                type: Boolean,
                default: function () {
                    return false;
                }
            },
            isLoadingDuplicates: {
                type: Boolean,
                default: function () {
                    return false;
                }
            },
            postUrl: {
                type: String,
                required: true
            }
        },
        data: function () {
            return {
                form: new Form(
                    this.revision || {
                        title: "",
                        category_id: "",
                        event_date: "",
                        select_month: "",
                        select_year_for_month: "",
                        select_quarter: "",
                        select_year_for_quarter: "",
                        select_half_year: "",
                        select_year_for_half_year: "",
                        select_year: "",
                        description: "",
                        street: "",
                        street_number: "",
                        postal_code: "",
                        state: "",
                        city: "",
                        phone: "",
                        website: "",
                        email: "",
                        source: "",
                        opening_times: "",
                        offer: "",
                        lat: 0,
                        lng: 0,
                        time_period: 1,
                        descinput: "",
                        images: []
                    },
                    new Errors({})
                ),
                geocoder: null,
                previousRevision: this.revision,
                message: null,
                error: false,
                errorGeoCode: false,
                duplicates: [],
                showForm: true,
                isSending: false,
                remainingEditTime: this.revision ? this.revision.remaining_edit_time : 0,
                editWindowTimer: null,
            };
        },
        created: function () {
          this.$gmapApiPromiseLazy().then(() => {
            this.geocoder = new google.maps.Geocoder();
          });
          if (this.isWithinEditWindow) {
            this.startEditWindowTimer();
          }
        },
        beforeDestroy: function() {
            if (this.editWindowTimer) {
                clearInterval(this.editWindowTimer);
            }
        },
        watch: {
            "form.street": function (val) {
                this.geocodeAddress(val + " " + this.form.street_number + ", " + this.form.state + " " +this.form.postal_code + " " + this.form.city);
            },
            "form.street_number": function (val) {
                this.geocodeAddress(this.form.street + " " + val + ", " + this.form.state + " " +this.form.postal_code + " " + this.form.city);
            },
            "form.postal_code": function (val) {
                this.geocodeAddress(this.form.street + " " + this.form.street_number + ", " + this.form.state + " " + val + " " + this.form.city);
            },
            "form.city": function (val) {
                this.geocodeAddress(this.form.street + " " + this.form.street_number + ", " + this.form.state + " " + this.form.postal_code + " " + val);
            },
            "form.state": function (val) {
                this.geocodeAddress(this.form.street + " " + this.form.street_number + ", " + val + " " + this.form.postal_code + " " + this.form.city);
            },
            "form.title": function (val) {
                this.checkDuplicates();
            }
        },
        computed: {
            dayTabSelected: function () {
                return this.form.time_period === 1;
            },
            monthTabSelected: function () {
                return this.form.time_period === 2;
            },
            quarterTabSelected: function () {
                return this.form.time_period === 3;
            },
            yearTabSelected: function () {
                return this.form.time_period === 4;
            },
            isWithinEditWindow: function() {
                return this.revision && this.revision.is_within_edit_window;
            }
        },
        methods: {
            formatTime(seconds) {
                if (seconds <= 0) return '0:00';
                const minutes = Math.floor(seconds / 60);
                const remainingSeconds = seconds % 60;
                return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
            },
            formatDate(date) {
                return moment(date).format("DD.MM.YYYY hh:mm");
            },
            clearMessages: function () {
                this.error = null;
                this.errorGeoCode = null;
            },
            onTabSelected: function (tabIndex) {
                // tabIndex starts with 0 so add 1
                this.form.time_period = tabIndex + 1;
            },
            onKeyUp: function (event) {
                this.form.errors.clear(event.target.id);
            },
            checkDuplicates: _.debounce(function () {
                this.$emit("duplicates-loading", true);
                this.form
                    .checkDuplicates("post", "/entries/duplicates")
                    .then(response => {
                        this.duplicates = response;
                        this.$emit("duplicates-loading", false);
                        this.$emit("duplicates-change", this.duplicates);
                    })
                    .catch(response => {
                        this.$emit("duplicates-loading", false);
                    });
            }, 1000),
            geocodeAddress: _.debounce(function (address) {
              if (!this.geocoder) {
                console.error("Geocoder is not initialized yet.");
                return;
              }
              this.geocoder.geocode({ "address": address }, function (results, status) {
                if (status === "OK") {
                  this.form.lat = results[0].geometry.location.lat();
                  this.form.lng = results[0].geometry.location.lng();
                  this.errorGeoCode = null;
                } else {
                  this.form.lat = 0;
                  this.form.lng = 0;
                  this.errorGeoCode = true;
                }
                this.checkDuplicates();
              }.bind(this));
            }, 500),
            onSubmit: function () {
                this.isSending = true;
                this.message = "";
                this.error = false;
                this.errorMessage = null;
                this.form.post(this.postUrl)
                    .then(response => {
                        this.message = response.message;
                        window.scrollTo(0, 0);
                        this.showForm = false;
                        this.isSending = false;
                    })
                    .catch(response => {
                        if (response === false) {
                            this.error = true;
                        } else if (response.error) {
                            this.error = true;
                            this.errorMessage = response.error;
                        }
                        window.scrollTo(0, 0);
                        this.isSending = false;
                    });
            },
            startEditWindowTimer: function() {
                this.editWindowTimer = setInterval(() => {
                    if (this.remainingEditTime > 0) {
                        this.remainingEditTime--;
                    } else {
                        clearInterval(this.editWindowTimer);
                    }
                }, 1000);
            }
        }
    };
</script>

